import { msg } from '@lingui/core/macro';
import { OldSubCategoryType } from '@/@types';

const seriesFilters = [
  { title: msg`Sci-Fi & Fantasy`, name: '', id: 'Sci-Fi & Fantasy' },
  { title: msg`Animation`, name: 'Animation', id: 'Animación' },
  { title: msg`Mistery`, name: 'Mistery', id: 'Misterio' },
  { title: msg`Comedy`, name: 'Comedy', id: 'Comedia' },
  { title: msg`Drama`, name: 'Drama', id: 'Drama' },
  { title: msg`Action & Adventure`, name: 'Action & Adventure', id: 'Action & Adventure' },
  { title: msg`Reality`, name: 'Reality', id: 'Reality' },
  { title: msg`Documental`, name: 'Documental', id: 'Documental' },
  { title: msg`Kids`, name: 'Kids', id: 'Kids' },
  { title: msg`Family`, name: 'Family', id: 'Familia' },
  { title: msg`Talk`, name: 'Talk', id: 'Talk' },
  { title: msg`Soap`, name: 'Soap', id: 'Soap' },
  { title: msg`Crime`, name: 'Crime', id: 'Crimen' },
  { title: msg`Western`, name: 'Western', id: 'Western' },
  { title: msg`War & Politics`, name: 'War & Politics', id: 'War & Politics' },
  { title: msg`News`, name: 'News', id: 'News' },
  { title: msg`Musical`, name: 'Musical', id: 'Musical' },
  { title: msg`Romance`, name: 'Romance', id: 'Romance' },
  { title: msg`History`, name: 'History', id: 'Historia' },
] as OldSubCategoryType[];

export default seriesFilters;
